import { GENERAL_CARD_INVITE_CODE } from '../../../constants/inviteCodes'
import GetStartedButton from '../../../shared/components/GetStartedButton'

const commonGetStartedButtonProps = {
  buttonText: "See if I'm Approved",
  inviteCode: GENERAL_CARD_INVITE_CODE,
}

const buttons = {
  hero: (
    <GetStartedButton
      id="home-page-hero-section-get-started-button"
      ctaName="Header - See if I'm Approved"
      {...commonGetStartedButtonProps}
    />
  ),
  noRisk: (
    <GetStartedButton
      id="home-page-no-risk-section-get-started-button"
      ctaName="No Risk to Credit - See if I'm Approved"
      color="secondary"
      {...commonGetStartedButtonProps}
    />
  ),
}

export default buttons
